import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const PdfPreviewModal = ({
  show, 
  pdfPreviewUrls, 
  currentPdfIndex, 
  setCurrentPdfIndex, 
  handleCancel, 
  handleFinalPublish 
}) => (
  <Modal
    show={show}
    onHide={handleCancel}
    backdrop="static"
    keyboard={false}
    dialogClassName='pdfPreviewModal'
    size="lg"
  >
    <Modal.Header closeButton>
      <Modal.Title>PDF Preview - {pdfPreviewUrls.length > 0 ? pdfPreviewUrls[currentPdfIndex].title : ''}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <iframe
        title="PDF Preview"
        src={pdfPreviewUrls.length > 0 ? pdfPreviewUrls[currentPdfIndex].url : ''}
        style={{ width: '100%', height: '500px' }}
        frameBorder="0"
      />
    </Modal.Body>
    <Modal.Footer className="justify-content-between">
      <Button variant="secondary" onClick={handleCancel} className="me-auto">Close</Button>
      <div className="d-flex justify-content-center">
        <Button
          variant="secondary"
          onClick={() => {
            if (currentPdfIndex > 0) setCurrentPdfIndex(currentPdfIndex - 1);
          }}
          disabled={currentPdfIndex === 0}
          className="mx-2"
        >
          {'<'}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            if (currentPdfIndex < pdfPreviewUrls.length - 1) setCurrentPdfIndex(currentPdfIndex + 1);
          }}
          disabled={currentPdfIndex === pdfPreviewUrls.length - 1}
          className="mx-2"
        >
          {'>'}
        </Button>
      </div>
      <Button variant="primary" onClick={handleFinalPublish}>Publish Report</Button>
    </Modal.Footer>
  </Modal>
);

export default PdfPreviewModal;
